import React, { MouseEvent } from 'react';
import styled from 'styled-components';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, StripeElementsOptions } from '@stripe/stripe-js';

import { ModalClose, ModalContainer, Overlay } from './CommonModal';
import { useBackgroundContext } from '../../contexts/BackgroundContext';
import { CoinPack } from '../../lib/coinPacks';
import CheckoutForm from './CheckoutForm';

import InlineSunshineCoin from 'Common/src/components/icons/InlineSunshineCoin';
import CloseIcon from 'Common/src/components/icons/CloseIcon';

declare const STRIPE_PUBLISHABLE_KEY: string;

const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY, {
  apiVersion: '2023-10-16'
});

const StripeModal = ({ close, coinPack, clientSecret }: { close: ()=> void, coinPack: CoinPack, clientSecret: string }) => {
  const backgroundContext = useBackgroundContext();

  const options: StripeElementsOptions = {
    // passing the client secret obtained from the server
    clientSecret,
    appearance: {
      variables: {
        colorText: backgroundContext.systemColors.backgroundText
      },
      rules: {
        '.Input': {
          color: '#000'
        }
      }
    }
  };

  const onModalClick = (e: MouseEvent) => {
    e.stopPropagation();
  };

  return <Overlay>
    <ModalContainer onClick={onModalClick}>
      <ModalClose onClick={close}><CloseIcon/></ModalClose>
      <ProductTitle><InlineSunshineCoin color={backgroundContext.colors.text}/> {coinPack.coinAmount} Coin Pack</ProductTitle>
      <ProductPrice>${coinPack.priceUSD}</ProductPrice>
      <OneTime>One-time charge</OneTime>
      <Elements stripe={stripePromise} options={options}>
        <CheckoutForm priceId={coinPack.priceId}/>
      </Elements>
    </ModalContainer>
  </Overlay>;
};

const ProductTitle = styled.h3`
  margin-top: 0;
  margin-bottom: .5em;
`;

const ProductPrice = styled.h4`
  margin-bottom: 0;
`;

const OneTime = styled.div`
  font-size: 14px;
  opacity: .8;
  margin-bottom: 20px;
`;

const ProductDescription = styled.div`
`;

export default StripeModal;
